<template>
	<div class="tpl gift-cash-wrap">
		<mt-header title="全部提现" fixed>
			<router-link :to="{name:'my-gifts'}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<mt-button slot="right" @click.native="selectAll">全选</mt-button>
		</mt-header>
		<ul class="gift-list gift-list-lv1">
			<li class="lv-item lv1-item" v-for="(item,index) in listInfo" ref="showlist">
				<p class="lv-item-title" :class="{'active':item.is_selected==1}" @click="chooseItAll(index,item.is_selected)">
					<span class="dot">
						<span class="dot-inner"></span>
					</span>
					<img :src="item.avatar"/>
					<span class="item-nickname">{{item.nickname}}</span>赠送的礼物
					<span class="show-more" @click.stop="showMore($event,index)"><img src="../../assets/img/mine/center_mark_ic_list_down.png" alt="" /></span>
				</p>
				<ul class="gift-list gift-list-lv2">
					<li class="lv-item" v-for="(i,n) in item.arr">
						<p class="lv-item-title"  :class="{'active':i.is_selected==1}" @click="chooseIt(index,n,i.is_selected)">
							<span class="dot">
								<span class="dot-inner"></span>
							</span>
							<img :src="i.girft_img_url"/>
							{{i.girft_name}}&times;{{i.g_nums}}
						</p>
					</li>
				</ul>
			</li>
		</ul>
		
		
		<div class="form-submit">
			<div class="form-price">
				<p>扣除后到账金额：<span class="num-name">￥</span><span class="num">{{moneySum}}</span></p>
				<p class="tip">礼物提现到平台扣取40%费用(其中包含个人意外所得税20%)</p>
			</div>
			<div class="form-btn">
				<button @click="submitAll">立即提现</button>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: "gift-all-cash",
		data() {
			return {
				uid: "",
				listInfo:"",
				moneySum:100,
			}
		},
		created() {
			console.log(this.$route.query)
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", false);

			this.getListInfo();
		},
		methods: {
			getListInfo(){
				this.$axios({
					url:"My/UserWithdrawalsAllList",
					method:"post",
					data:{
						uid:this.uid,
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						res.data.data.map(item=>{
							item.is_selected = 0;
							item.arr.map(i=>{
								i.is_selected = 0;
							})
						});
						console.log(res.data.data);
						this.listInfo = res.data.data;
					}
					
				}).catch(err=>{
					console.log(err)
				})
			},
			chooseItAll(index,is){
				console.log(this.listInfo[index].is_selected)
				this.listInfo[index].is_selected = !is;
//				if(!is == 1){
					this.listInfo[index].arr.map(item=>{
						item.is_selected = !is
					})
//				}
			},
			chooseIt(index,n,is){
				console.log(index,n,is);
				console.log(this.listInfo[index].arr[n].is_selected);
				this.listInfo[index].arr[n].is_selected = !is;
			},
			showMore(event,index){
				let ele = this.$refs.showlist[index].getElementsByTagName("ul")[0];
				console.log(event.currentTarget);
				if(ele.style.display == "none"){
					ele.style.display = "block";
					event.currentTarget.classList.add("up");
				}else{
					ele.style.display = "none";
					event.currentTarget.classList.remove("up");
				}
			},
			selectAll(){
				this.listInfo.map(item=>{
					item.is_selected = 1;
					item.arr.map(i=>{
						i.is_selected = 1;
					})
				})
			},
			submitAll(){
				console.log(this.listInfo);
				let a = "";
				let b = "";
				this.listInfo.map(item=>{
					item.arr.map(i=>{
						if(i.is_selected == 1&&i.type==1){
							a+=i.g_id+',';
						}else if(i.is_selected == 2&&i.type==1){
							b+='';
						}
					})
				})
				var reg=/,$/gi;
				console.log(a.replace(reg,""),b.replace(reg,""));
				this.isLogin();
				this.$axios({
					url:"My/GiftExchangePeachCoinAll",
					method:"post",
					data:{
						uid:this.uid,
						type_1:a.replace(reg,""),
						type_2:b.replace(reg,""),
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code!=400){
						this.$toast({
							message: "兑换成功",
							position: "bottom",
							duration: 3000
						});
						this.getListInfo()
					}else{
						this.$toast({
							message: "兑换失败，请重试",
							position: "bottom",
							duration: 3000
						});
					}
				}).catch(err=>{
					console.log(err);
				})
			}
		}
	}
</script>

<style scoped>
	>>>.mint-button-text{
		color: #5415F9;
	}
	.gift-cash-wrap {
		padding-top: 2.5rem;
		padding-bottom: 3.5rem;
	}
	.gift-list .dot{
		width: 1.5rem;
		height: 1.5rem;
		border-radius: 50%;
		border: 1px solid #bdbdbd;
		margin-right: 0.5rem;
		display: flex;
		justify-content: center;
		align-items: center;
		
	}
	.gift-list .lv-item-title.active .dot{
		border-color: #FF6161;
	}
	.gift-list .dot-inner{
		width: 1rem;
		height: 1rem;
		background: #FF6161;
		border-radius: 50%;
		opacity: 0;
	}
	.gift-list .lv-item-title.active .dot-inner{
		opacity: 1;
	}
	.gift-list li{
		background: #fff;
	}
	.gift-list li.lv1-item{
		margin-bottom: 4px;
	}
	.lv-item-title{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0.5rem 1rem;
		font-size: 1rem;
		font-weight: bold;
		position: relative;
		border-bottom: 1px solid #f3f3f3;
	}
	.lv-item-title .show-more{
		position: absolute;
		right: 0;
		transition: 300ms;
	}
	.lv-item-title .show-more.up{
		transform: rotate(180deg);
	}
	.gift-list-lv2 .lv-item-title{
		font-size: 0.8rem;
		color: #7B7B7B;
		font-weight: normal;
	}
	.lv-item-title img{
		width: 1.5rem;
		height: 1.5rem;
		border-radius: 50%;
		margin-right: 0.3rem;
	}
	.lv-item-title .item-nickname{
		color: #5415F9;
	}
	
	.form-submit {
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: fixed;
		width: 100%;
		bottom: 0;
		left: 0;
		background: #fff
	}
	
	.form-submit button {
		background: linear-gradient(108deg, rgba(84, 21, 249, 0.4) 0%, rgba(84, 21, 249, 0.7) 100%);
		color: #fff;
		font-size: 0.9rem;
		padding: 1rem 1.5rem;
		border: 0;
		outline: 0;
	}
	
	.form-submit .form-price {
		padding-left: 1rem;
		font-size: 0.9rem;
		color: #282828;
	}
	
	.form-submit .form-price .num {
		font-size: 1.5rem;
		color: #5415F9;
		font-weight: bold;
	}
	
	.form-submit .form-price .num-name {
		font-size: 0.5rem;
		color: #7b7b7b;
	}
	
	.form-submit .form-price .tip {
		font-size: 0.5rem;
		color: #7b7b7b;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/GiftAllCash.vue